import React from "react";
import "./Common_Title.css";

const Common_Title = ({ title, subtitle, logo }) => {
  return (
    <>
      <div className="commontitle_div">
        <p className="maintitle">{title}</p>
        {subtitle && (
          <h5 className="subtitle">
            {subtitle} 
          </h5>
        )}
      </div>
    </>
  );
};

export default Common_Title;
